<template>
  <nav
    class="navbar navbar-expand-lg navbar-dark"
    :class="!isMap ? `mb-4` : ``"
    v-if="!mobileView && !auth.iframeSrc"
  >
    <div class="container">
      <router-link to="/" class="navbar-brand">
        <img src="/images/logo-gfx.png" alt class="brand mr-2" />
        Community Care Connection
      </router-link>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        data-v-step="mainHeaderMenu"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav mr-auto">
          <li class="nav-item">
            <router-link
              to="/"
              class="nav-link"
              data-toggle="collapse"
              data-v-step="vendorMap"
              data-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
            >
              <i class="fas fa-compass mr-1"></i> Vendor Map
            </router-link>
          </li>
          <li class="nav-item" v-if="user.isClient">
            <router-link
              to="/become-vendor"
              class="nav-link"
              data-toggle="collapse"
              data-v-step="becomeVendor"
              data-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
            >
              <i class="fas fa-building mr-1"></i> Become a vendor
            </router-link>
          </li>
          <li class="nav-item">
            <router-link
              to="/orders"
              class="nav-link"
              data-v-step="myReferrals"
              data-toggle="collapse"
              data-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
            >
              <i class="fas fa-chart-line mr-1"></i> My Referrals
              <badge
                type="pill"
                color="info"
                class="font-weight-bold"
                v-if="orders.newReceivedCount > 0"
                >{{ orders.newReceivedCount }}</badge
              >
            </router-link>
          </li>
          <li class="nav-item">
            <a
              href="/"
              class="nav-link"
              data-toggle="collapse"
              data-v-step="inviteUser"
              data-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              @click.prevent="addUsersToInvite"
            >
              <i class="fas fa-user-plus"></i> Invite User
            </a>
          </li>
          <client-nav :user="user" v-if="user.isClient" />
          <vendor-nav :user="user" v-if="user.isVendor" />
          <admin-nav :user="user" v-if="user.isAdmin" />
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
import Auth from "../auth";
import { mapState, mapActions } from "vuex";
import { default as VendorNav } from "./Nav/Vendor";
import { default as AdminNav } from "./Nav/Admin";
import { default as ClientNav } from "./Nav/Client";

export default {
  name: "Navbar",
  computed: {
    ...mapState(["auth", "orders"]),
    isMap: function () {
      let routes = ["/", "/vendors/search"];
      if (routes.includes(this.$route.path)) {
        return true;
      }
      return false;
    },
    mobileView: function () {
      if (
        this.$route.query.src &&
        this.$route.query.src.toLowerCase() == "mobile"
      ) {
        return true;
      }
      return false;
    },
    user: function () {
      return Auth.user.get();
    },
  },
  mounted() {
    if (this.auth.user) {
      this.getNewReceivedReferralsCount();
      setInterval(() => {
        this.getNewReceivedReferralsCount();
      }, 30 * 1000);
    }
  },
  methods: {
    ...mapActions({
      getNewReceivedReferralsCount: "orders/newReceivedCount",
    }),
    addUsersToInvite: function () {
      this.$store.dispatch("showModal", "header-invite-users");
    },
  },
  components: {
    ClientNav,
    VendorNav,
    AdminNav,
  },
};
</script>
